export default {
  LIST (state, value) {
    state.list = Array.isArray(value) ? value : []
  }
}
